import Modal from "../../../../components/general/Modal";
import {
  Container,
  FlowName,
  Footer,
  SubTitle,
  Title,
  DivIcon,
} from "./styles";
import Button from "../../../../components/general/Button";
import Close from "../../../../assets/icons/Close";

/**
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.onClose
 * @param {() => void} props.onConfirm
 * @param {string=} props.selector
 * @param {string=} props.className
 * @param {string} props.title
 */
export const RemoveRdmUserModal = ({
  isOpen,
  onClose,
  onConfirm,
  selector,
  className,
  title,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      selector={selector}
      className={className}
      onClose={onClose}
    >
      <Container>
        <Title>Excluir RDM </Title>
        <SubTitle style={{ color: "red" }}>
          Deseja excluir o usuário do RDM?
        </SubTitle>
        <FlowName>{title}</FlowName>
        <Footer>
          <Button
            outline
            content="Cancelar"
            width={"11.3125rem"}
            height={"2.625rem"}
            onClick={onClose}
          />
          <Button
            content="Sim, excluir"
            width={"11.3125rem"}
            height={"2.625rem"}
            onClick={onConfirm}
          />
        </Footer>
        <DivIcon>
          <Close onClick={onClose} />
        </DivIcon>
      </Container>
    </Modal>
  );
};
